import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchPerk({ id, callbacks }) {
  try {
    const { data } = yield call(api.fetchPerk, id);
    yield put(Actions.fetchPerkSuccess(data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, data);
    }
  } catch (error) {
    yield put(Actions.fetchPerkFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure);
    }
  }
}

function* watchFetchPerk() {
  yield takeLatest(Actions.FETCH_PERK_REQUEST, fetchPerk);
}

export default function* info() {
  yield all([fork(watchFetchPerk)]);
}
